import {
  initVisitor,
  Visitor,
  VisitorBreakdownGraph,
} from 'src/app/models/visitor';
import { initUser, IUser, UserRegDetails } from 'src/app/models/user';
import { inituserList, userList } from 'src/app/models/selectMenu';
import { IConstants } from 'src/app/app.constants';
import { IProperty } from 'src/app/models/property';
import { IAssets } from 'src/app/models/assets';
import { IIncidents, IncidentBreakdownGraph } from 'src/app/models/incident';
import { NumberPlates } from 'src/app/models/numberPlates';
import { IFaceTimeline } from 'src/app/models/faceTimeline';
import { INoticeBoardPosts } from 'src/app/models/notice-board';
import { IUserEvents } from 'src/app/models/user-events';
import { IUserPolls } from 'src/app/models/user-polls';
import { ICountry } from 'src/app/models/country';
import { IEmployee } from 'src/app/models/IEmployee';
import { rolesPermission } from 'src/app/modules/settings/components/settings-container/settings-container.component';
import { ComplaintsTickets } from 'src/app/models/tickets';
import {
  IAdvancedSOSState,
  initIAdvancedSOSState,
} from './aumye-advanced-sos.state';
import { IAnalyticsState, initIAnalyticsState } from './aumye-analytics.state';

export interface IDashboardState {
  flows: {
    isDashboard: boolean;
    isReports: boolean;
    isAnalytics: boolean;
    isMediaWall: boolean;
    isAssets: boolean;
    isCalendar: boolean;
    isManageUser: boolean;
    isSettings: boolean;
    isUserProfile: boolean;
    isVisitorGateEntry: boolean;
    isIncidentManualEvent: boolean;
    isPreverifiedFlow: boolean;
    isAumyeCommunityFlow: boolean;
    isShowWaitingSection: boolean;
  };
  status: {
    isFetchingAPIRequest: boolean;
    isLodingVisitorDashboardData: boolean;
    isVisitorDataLoaded: boolean;
    isIncidentDataLoaded: boolean;
    isDashboardDataLoaded: boolean;
    isPushNotificationTokenRegistered: boolean;
    isAssetsLoaded: boolean;
    isGettingEvidence: boolean;
    isOrgUserDetailsLoaded: boolean;
    isNumberPlatesLoaded: boolean;
    isError: boolean;
    isNumberFound: boolean;
    isSimulationStarted: boolean;
  };
  isAdmin: boolean;
  organizationDetails: {
    orgId: string;
    TotalUser: number;
    TotalAdmin: number;
    TotalIncident: number;
    TotalVisitor: number;
  };
  visitorDetails: {
    visitorList: Visitor[];
    singleTotal: number;
    totalSingleVerified: number;
    totalSingleUnverified: number;
    totalVerified: number;
    totalUnverified: number;
    totalVisitor: number;
    totalPending: number;
    totalAutoRejected: number;
    totalRejected: number;
    breakdownGraphData: VisitorBreakdownGraph[];
  };
  incidentDetails: {
    incidentList: IIncidents[];
    criticalIncidentList: IIncidents[];
    mediumIncidentList: IIncidents[];
    lowIncidentList: IIncidents[];
    noIncidentList: IIncidents[];
    recentActivityIncidentList: IIncidents[];
    totalIncidents: number;
    totalOpen: number;
    totalClosed: number;
    todaysIncident: number;
    todaysOpen: number;
    todaysClosed: number;
    totalSnoozed: number;
    totalUnassigned: number;
    breakdownGraphData: IncidentBreakdownGraph[];
    incidentGraphCounts: IncidentPieGraph;
    totalFire: number;
    totalIntrusion: number;
    totalFaceMatch: number;
    totalAnpr: number;
    manualCount: number;
    securityCallbacksCount: number;
    serviceRequestCount: number;
    soSAlertsCount: number;
    systemFailureCount: number;
    deviceFailureCount: number;
    claimsCount: number;
  };
  facaTimeline: IFaceTimeline[];
  orgUserList: UserRegDetails[];
  loggedInUserDetails: UserRegDetails;
  noticeBoardPosts: INoticeBoardPosts[];
  userEvents: IUserEvents[];
  userInventory: IInventory[];
  userPolls: IUserPolls[];
  orgAssetList: {
    property: IProperty[];
    assets: IAssets[];
  };
  userList: userList[];
  orgVehicleNumberPlates: NumberPlates[];
  orgUsers: {
    userId: string;
    userDetail: IUser;
  };
  gateEntryVisitor: {
    isHostNotified: boolean;
    visitorId: string;
    visitorDetails: Visitor;
    isFetchingHostStatus: boolean;
  };
  manualIncidentEvent: {
    isNotified: boolean;
    visitorId: string;
    visitorDetails: Visitor;
    isFetchingHostStatus: boolean;
  };
  Error: {
    errorMessage: string;
  };
  Common: {
    countries: {
      list: ICountry[];
      isFetching: boolean;
      Errors: any;
    };
    // states: {
    //     list: Array<IState>,
    //     isFetching: boolean;
    //     Errors: any;
    // };
    Country: any;
    State: any;
  };
  Constants: IConstants;
  Employees: IEmployee[];
  Searchednumber: {
    numberPlate: string;
    incidentId: string;
    matchScore: number;
  };
  OrganizationSettings: IOrgSettings;
  complaintsTickets: ComplaintsTickets[];
  claimTickets: ComplaintsTickets[];
  requestsTickets: ComplaintsTickets[];
  orgSOSData: IAdvancedSOSState;
  orgRiskData: IAnalyticsState;
  notifications: INotifications[];
}

export const initIDashboardState: IDashboardState = {
  flows: {
    isDashboard: false,
    isReports: false,
    isUserProfile: false,
    isAnalytics: false,
    isMediaWall: false,
    isAssets: false,
    isCalendar: false,
    isManageUser: false,
    isSettings: false,
    isVisitorGateEntry: false,
    isIncidentManualEvent: false,
    isPreverifiedFlow: false,
    isAumyeCommunityFlow: false,
    isShowWaitingSection: false,
  },
  status: {
    isFetchingAPIRequest: false,
    isLodingVisitorDashboardData: false,
    isGettingEvidence: false,
    isVisitorDataLoaded: false,
    isIncidentDataLoaded: false,
    isDashboardDataLoaded: false,
    isPushNotificationTokenRegistered: false,
    isAssetsLoaded: false,
    isNumberPlatesLoaded: false,
    isOrgUserDetailsLoaded: false,
    isError: false,
    isNumberFound: false,
    isSimulationStarted: false,
  },
  isAdmin: false,
  organizationDetails: {
    orgId: null,
    TotalUser: null,
    TotalAdmin: null,
    TotalIncident: null,
    TotalVisitor: null,
  },
  complaintsTickets: [],
  claimTickets: [],
  requestsTickets: [],
  loggedInUserDetails: null,
  orgUserList: [],
  userList: [],
  noticeBoardPosts: [],
  userEvents: [],
  userPolls: [],
  orgVehicleNumberPlates: [],
  orgUsers: {
    userId: null,
    userDetail: initUser,
  },
  userInventory: [],
  orgAssetList: {
    property: [],
    assets: [],
  },
  notifications: [],
  visitorDetails: {
    visitorList: [],
    totalVerified: null,
    totalUnverified: null,
    totalVisitor: null,
    singleTotal: 0,
    totalSingleVerified: 0,
    totalSingleUnverified: 0,
    totalPending: 0,
    totalAutoRejected: 0,
    totalRejected: 0,
    breakdownGraphData: [],
  },
  incidentDetails: {
    incidentList: [],
    criticalIncidentList: [],
    mediumIncidentList: [],
    lowIncidentList: [],
    noIncidentList: [],
    recentActivityIncidentList: [],
    totalIncidents: null,
    totalOpen: null,
    totalClosed: null,
    todaysIncident: null,
    todaysOpen: null,
    todaysClosed: null,
    totalSnoozed: null,
    totalUnassigned: null,
    breakdownGraphData: [],
    incidentGraphCounts: null,
    totalFire: null,
    totalIntrusion: null,
    totalFaceMatch: null,
    totalAnpr: null,
    manualCount: 0,
    securityCallbacksCount: 0,
    serviceRequestCount: 0,
    soSAlertsCount: 0,
    systemFailureCount: 0,
    deviceFailureCount: 0,
    claimsCount: 0,
  },
  facaTimeline: [],
  gateEntryVisitor: {
    isHostNotified: false,
    visitorId: null,
    visitorDetails: initVisitor,
    isFetchingHostStatus: false,
  },
  manualIncidentEvent: {
    isNotified: false,
    visitorId: null,
    visitorDetails: initVisitor,
    isFetchingHostStatus: false,
  },
  Error: {
    errorMessage: null,
  },
  Common: {
    countries: {
      list: [],
      isFetching: false,
      Errors: null,
    },
    // states: {
    //     list: Array<IState>,
    //     isFetching: boolean;
    //     Errors: any;
    // };
    Country: null,
    State: null,
  },
  Constants: null,
  Employees: [],
  Searchednumber: {
    numberPlate: null,
    incidentId: null,
    matchScore: null,
  },
  OrganizationSettings: null,
  orgSOSData: initIAdvancedSOSState,
  orgRiskData: initIAnalyticsState,
};
export interface INotifications {
  notificationOrg: string;
  notificationTitle: string;
  notificationBody: string;
  notificationFlowType: string;
  notificationId: string;
  notificationPeopleId: string[];
  notificationLink?: string;
  timestamp?: Date;
  read?: boolean;
  type?: 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR';
}
export interface IOrgSettings {
  customRoles: string[];
  customRolePermission: rolesPermission[];
  algorithmSetting: {
    faceDetectionThreshold: number;
    plateDetectionThreshold: number;
    ocrThreshold: number;
    stringComparisonThreshold: number;
    intrusionThreshold: number;
    fireThreshold: number;
  };
  emergencyAssistance: { role: string; value: boolean }[];
  settingLastUpdatedBy: string;
  settingLastUpdatedDate: Date;
  securityDefault: { fullName: string; userId: string };
  ownerLists: IOwnerIncident[];
}
export interface IOwnerIncident {
  ownerName: string;
  ownerEmail: string;
  ownerPhone: string;
}
export interface IInventory {
  inventoryDetails: IUserInventoryList[];
  inventoryCreatedBy: string;
  inventoryCreatedDate: Date;
}
export interface IUserInventoryList {
  inventoryId: string;
  listName: string;
  inventoryItems: IItemLists[];
  listAddDate: Date;
  delivery: Date;
  assignEvent: string;
  assignVendor: string;
}

export interface IItemLists {
  itemName: string;
  quantity: string;
  units: string;
}
export interface IncidentPieGraph {
  openCount: number;
  closedCount: number;
  inProgressCount: number;
  onHoldCount: number;
  completeCount: number;
  approvedCount: number;
  rejectedCount: number;
  verifiedCount: number;
  snoozedCount: number;
  fireCount: number;
  anprCount: number;
  intrusionCount: number;
  manualCount: number;
  autoCount: number;
  securityCallbacksCount: number;
  serviceRequestCount: number;
  soSAlertsCount: number;
  systemFailureCount: number;
  deviceFailureCount: number;
  claimsCount: number;
}
